/**
 * Owner Activity Repository
 * 오너 활동 모니터링 데이터 액세스 계층
 */

import axios from 'axios';
import { API_BASE_URL } from '../../../config/api';
import {
  OwnerActivityLog,
  InactiveOwner,
  OwnerActivitySummary,
  OwnerLastActivity,
} from '../models';

export class OwnerActivityRepository {
  private baseUrl = `${API_BASE_URL}/api/v1/admin/owner-activities`;

  private getAuthHeaders() {
    const token = localStorage.getItem('admin_token');
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  /**
   * 비활성 오너 목록 조회
   */
  async getInactiveOwners(days = 7): Promise<InactiveOwner[]> {
    const response = await axios.get(`${this.baseUrl}/inactive`, {
      headers: this.getAuthHeaders(),
      params: { days },
    });
    return response.data;
  }

  /**
   * 특정 오너의 활동 로그 조회
   */
  async getOwnerActivityLogs(
    ownerId: string,
    limit = 50,
    offset = 0
  ): Promise<OwnerActivityLog[]> {
    const response = await axios.get(`${this.baseUrl}/owners/${ownerId}/logs`, {
      headers: this.getAuthHeaders(),
      params: { limit, offset },
    });
    return response.data;
  }

  /**
   * 전체 활동 요약 조회
   */
  async getActivitySummary(): Promise<OwnerActivitySummary> {
    const response = await axios.get(`${this.baseUrl}/summary`, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }

  /**
   * 모든 오너의 마지막 활동 정보 조회
   */
  async getAllOwnersLastActivity(): Promise<OwnerLastActivity[]> {
    const response = await axios.get(`${this.baseUrl}/owners/last-activity`, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }
}

// 싱글톤 인스턴스
export const ownerActivityRepository = new OwnerActivityRepository();
